import type { App } from 'vue'
import { ComponentI } from '@/typescript/types/abstracts/plugins/ComponentTypes'
import { Plugin } from 'vue'

const initRegisterLayouts: Plugin<[]> = {
  async install(vue: App) {
    const componentList: Record<string, ComponentI> = import.meta.glob('../components/layout/*.vue', { eager: true })

    Object.entries(componentList).forEach(([key, component]) => {
      const componentString = key.split('/')
      const componentName = componentString[componentString.length - 1].split('.')[0]
      vue.component(componentName, component?.default)
    })
  },
}

export default initRegisterLayouts
